import { ExtendCSS } from 'vcc-ui';

export const heroImageStyles: ExtendCSS = ({ theme: { baselineGrid } }) => ({
  marginTop: baselineGrid * 5,
  fromM: {
    height: 370,
    marginTop: baselineGrid * 7,
  },
});
